import axios from 'axios'
import {Message} from 'element-ui';
import store from '../store'

const instance = axios.create({
    baseURL: process.env.VUE_APP_URL,
    timeout: 5000
})

instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 429) {
            Message({
                showClose: true,
                message: '请求太频繁，请稍后再试',
                type: 'error'
            });
        } else if (error.response.status === 500) {
            Message({
                showClose: true,
                message: '服务器连接失败，请尝试重新登录',
                type: 'error'
            });
        } else if (error.response.status === 404) {
            Message({
                showClose: true,
                message: '很抱歉！您访问的资源不存在',
                type: 'error'
            });
        } else {
            Message({
                showClose: true,
                message: error.response.data.message,
                type: 'error'
            });
        }
        
        return Promise.reject(error)
    }
)

const checkToken = async () => {
    // 从缓存中取出 Token
    const accessToken = store.getters.accessToken
    const expiredAt = store.getters.accessTokenExpiredAt

    // 如果 token 过期了，则调用刷新方法
    if (accessToken && new Date().getTime() > expiredAt) {
        try {
            return store.dispatch('refresh')
        } catch (err) {
            return store.dispatch('login')
        }
    }
}

const request = async (url, options) => {
    return instance.request(url, options)
}

const authRequest = async (url, options) => {
    await checkToken()
    options.headers = {
        Authorization: 'Bearer ' + store.getters.accessToken
    }
    return await request(url, options)
}

export {
    request,
    authRequest
}